import * as React from 'react'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { useNavigate } from 'react-router-dom'
import { NavigationPath } from '@models/routes'

export const ShopPOSView: React.FC = () => {
  const user = useAuthenticatedUser()

  const navigate = useNavigate()

  React.useEffect(() => {
    navigate(NavigationPath.ShopPOSWithParams.replace(':resort_id', String(user.resorts[0].id)))
  }, [])

  return null
}
